export default __webpack_public_path__ + "src/assets/nft-dashboard.b25b608db4dda216a8ae960ec9023316.svg";